import { useCallback, useMemo, useState } from "react";
import { IconButton } from "@mui/material";
import { MdStar, MdStarBorder } from "react-icons/md";
import { useSelector } from "react-redux";
import { FavoriteRegionDialog } from "./favorite-region-dialog";
import { DataRanges } from "src/utils/configs";

const fieldByDataRange = (dataRange) => {
  if (dataRange === DataRanges.SIDO) return "selectedSidos";
  if (dataRange === DataRanges.GUNGU) return "selectedGungus";
  return "selectedDongs";
};

/**
 * 관심지역 별표 버튼.
 * - 어느 그룹이라도 현재 region이 등록되어 있으면 노란색.
 * - 클릭 시 관심지역 다이얼로그 오픈.
 *
 * @param {string} regionId
 * @param {string} regionName
 * @param {string} dataRange  - DataRanges.SIDO/GUNGU/DONG ("S"/"G"/"D")
 * @param {string} parentName
 * @param {number} iconSize
 */
export const FavoriteRegionStarButton = ({
  regionId,
  regionName,
  dataRange,
  parentName,
  iconSize = 14,
}) => {
  const regionGroups = useSelector((state) => state.group.regionGroups || []);
  const [open, setOpen] = useState(false);

  const field = fieldByDataRange(dataRange);

  const isFavorite = useMemo(() => {
    if (!regionId) return false;
    return regionGroups.some((g) => (g[field] || []).includes(regionId));
  }, [regionGroups, regionId, field]);

  const handleClick = useCallback((e) => {
    e.stopPropagation();
    setOpen(true);
  }, []);

  if (!regionId) return null;

  return (
    <>
      <IconButton
        size="small"
        sx={{ p: 0.2 }}
        onClick={handleClick}
        title={isFavorite ? "관심지역에 등록됨" : "관심지역 등록"}
      >
        {isFavorite
          ? <MdStar size={iconSize} color="#FFB400" />
          : <MdStarBorder size={iconSize} color="#999" />}
      </IconButton>
      <FavoriteRegionDialog
        open={open}
        onClose={() => setOpen(false)}
        regionId={regionId}
        regionName={regionName}
        dataRange={dataRange}
        parentName={parentName}
      />
    </>
  );
};
